// Google Tag Manager — laddas i <head>, styrt av samma Consent Mode v2 som GA4.
// Container-ID kan överstyras via VITE_GTM_CONTAINER_ID; annars används
// organisationens aktiva container.

export const GTM_CONTAINER_ID =
  (import.meta.env.VITE_GTM_CONTAINER_ID as string | undefined) ||
  "GTM-MSPBL6ZN";

/** Sätter default consent *innan* GTM-scriptet laddas, så inga taggar
 *  lagrar data förrän besökaren godkänt alla cookies. */
export function gtmConsentDefaultScript(): string {
  return `
window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
var c=false;try{c=localStorage.getItem('fenny_consent')==='all';}catch(e){}
gtag('consent','default',{
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  analytics_storage: c ? 'granted' : 'denied',
  wait_for_update: 500
});
  `.trim();
}

/** Standard GTM-loader (head-snippet). */
export function gtmLoaderScript(containerId: string): string {
  return `
(function(w,d,s,l,i){
  w[l]=w[l]||[];
  w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
  var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),
      dl=l!='dataLayer'?'&l='+l:'';
  j.async=true;
  j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
  f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${containerId}');
  `.trim();
}

/** noscript-iframe som visas när JavaScript är avstängt. */
export function gtmNoscriptIframeUrl(containerId: string): string {
  return `https://www.googletagmanager.com/ns.html?id=${containerId}`;
}
